<div class="container-fluid">
  <mat-card>
    <mat-card-content [class.hide-content]="!(projectControlRates && employees)">
      <a id="projectControlRateCreate" mat-raised-button [routerLink]="['create']" color="primary"
         matTooltip="Create Project Control Rate" [matTooltipPosition]="'right'">
        <mat-icon class="add-icon">add</mat-icon>
        Project Control Rate
      </a>

      <br />
      <div class="col-md-12">
        <fieldset>
          <legend>
            Search Selection
          </legend>
          <form [formGroup]="filterForm">
            <mat-form-field>
              <input matInput type="text" placeholder="Filter by Project Control Rate Name" id="projectControlRateName" formControlName="projectControlRateName" />
            </mat-form-field>
            <mat-form-field>
              <mat-select formControlName="createdBy" id="createdBy" disableOptionCentering #employee placeholder="Filter By Created By">
                <mat-option [value]="''">
                  None
                </mat-option>
                <mat-option *ngFor="let emp of employees" [value]="emp.employeeId">
                  {{emp.firstName + " " + emp.lastName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" (click)="resetFilters()" title="Clear Filters" id="resetBtn">
              <mat-icon>clear</mat-icon>
            </button>
          </form>
        </fieldset>
      </div>
      <br />
      <div class="col-md-12">
        <mat-table #table matSort [dataSource]="projectControlRateDataSource" class="apply-border">
          <ng-container matColumnDef="projectControlRateName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="sortable"> Name </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span> {{element.projectControlRateName}}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="projectControlRateDescription">
            <mat-header-cell *matHeaderCellDef> Description </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.projectControlRateDescription}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="createdBy">
            <mat-header-cell *matHeaderCellDef> Created By</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{this.employees | employeeFilter: element.createdByEmployeeId}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="projectControlRateActions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let element" id="kebabMenu">
              <ng-container>
                <button mat-icon-button [matMenuTriggerFor]="menu" [attr.data-id]="element.projectControlRateId">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item [routerLink]="['edit', element.projectControlRateId]">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="deleteProjectControlRate(element.projectControlRateId)">
                    <mat-icon>delete_outline</mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </ng-container>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>
      <div>
        <mat-paginator #paginator [length]="projectControlRateDataSource?.data.length" [pageIndex]="0" [pageSize]="50"
                       [pageSizeOptions]="[5, 25, 50, 100]">
        </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>
